package app.bloomey.web.core.data.models

enum class Environment {
    development, staging, production
}